import { IErrors } from '../../../../types/reducers/rosreestrData';

export const hasError = (errors: IErrors, value: string): boolean =>
  errors.validationError.value === value || errors.notFoundError?.value === value;
